<template>  	
		
    <div class="questions__intro-text">
        <div class="row">
            <div class="col-12 col-xs-12">
                <p>Click on the answer to each question below, then click on calculate.</p>
            </div>
        </div>
    </div>

</template>

<script>
export default {
	name: "Warning"
};
</script>
